module.exports = __webpack_public_path__ + "static/img/211_phase_function_Paper_PointsHejduk_Prediction.2630c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/211_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nOpo
// module chunks = 0